import axios from "axios";

export const saveProfileCustomQuestion = (question, data, callback) => {
  let method, url;
  if (question) {
    method = "patch";
    url = `/api/profile_custom_questions/${question.id}`;
  } else {
    method = "post";
    url = "/api/profile_custom_questions";
  }

  axios({
    method: method,
    data: data,
    url: url,
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => callback(response))
    .catch(err => callback(err.response));
};

export function switchState(question_id, data, callback) {
  axios({
    method: "patch",
    url: `/api/profile_custom_questions/${question_id}/switch_state`,
    data: data,
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => callback(response))
    .catch(err => callback(err.response));
}

export function deleteQuestion(question_id, callback) {
  axios({
    method: "delete",
    url: `/api/profile_custom_questions/${question_id}`,
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => callback(response))
    .catch(err => callback(err.response));
}